/* eslint-disable */
import { ContactSection } from "../components/Contactform.component";
import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import bigCover from '../assets/images/big-cover.jpg';

export const Contacts: React.FC = () => {
    return (
        <>
            <BreadcrumpComponent
                title="Nos contacts"
                subtitle="Si vous souhaitez plus d’informations sur l’un de nos programmes académiques ou si vous avez d’autres questions, préoccupations ou avez besoin d’une aide et de conseils d’ordre général, nous sommes heureux de vous aider. Veuillez utiliser la liste ci-dessous pour vous aider à trouver les coordonnées que vous recherchez. L’adresse physique de l’Université Libre des Pays des Grands Lacs pour le campus de Moïse, qui abrite notre administration centrale, se trouve à l’avenue du Lac, N°2 Quartier Himbi II (Campus Moïse), commune de Goma, Ville Goma, Province du Nord-kivu."
                imageCover={bigCover}
            />

            <div className="padding-x">
                <ContactSection />

                <main className="wp-block-group alignfull site-content has-background padding-x is-layout-constrained wp-block-group-is-layout-constrained" id="map" style={{ "background": "linear-gradient(180deg,rgb(250,250,250) 72%,rgba(0,58,102,0) 72%)", "marginTop": 0, "paddingTop": "var(--wp--preset--spacing--x-large)", "paddingBottom": 0 }}>
                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-28f84493 wp-block-columns-is-layout-flex">
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ "flexBasis": "25%" }}></div>

                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: "50%" }}>
                            <PageSectionHeader
                                eyebrow="Campus"
                                title="Localisation et accès"
                                lead="La gestion de nos services administratifs et académiques se centralise au niveau de notre rectorat, situé dans le quartier Himbi II, sur l'Avenue du Lac. Planifiez vos visites grâce à notre outil de géolocalisation."
                                align="center"
                            />
                        </div>
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ "flexBasis": "25%" }}></div>
                    </div>

                    <div style={{ "height": "60px" }} aria-hidden="true" className="wp-block-spacer"></div>

                    <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-28f84493 wp-block-columns-is-layout-flex" style={{ "borderRadius": "0px" }}>
                        <div className="wp-block-column is-vertically-aligned-center is-layout-flow wp-block-column-is-layout-flow" style={{ "borderStyle": "none", "borderWidth": "0px", "paddingTop": 0, "paddingRight": 0, "paddingBottom": "var(--wp--preset--spacing--medium)", "paddingLeft": 0 }}>
                            <div className="map-container" style={{ marginTop: '40px', width: '100%', height: '400px' }}>
                                <div className="mapouter" style={{ position: 'relative', textAlign: 'right', width: '100%', height: '450px' }}>
                                    <div className="gmap_canvas" style={{ overflow: 'hidden', background: 'none!important', width: '100%', height: '450px' }}>
                                        <iframe
                                            width="100%"
                                            height="450px"
                                            style={{ border: 0 }}
                                            allowFullScreen
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            src="https://www.google.com/maps/embed/v1/place?q=universite%20libre%20des%20pays%20des%20grands%20lacs&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
                                    </div>
                                    <a href="https://norsumediagroup.com/embed-google-map-website-free" target="_blank" rel="noopener noreferrer" className="gme-generated-link">Embed Map on Website for Free</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            {/* Répertoire du personnel */}
            {/* <StaffDirectory /> */}
        </>
    );
}